var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"pa-3"},[_c('v-flex',{class:_vm.cardFlexClass},[_c('v-card',{staticClass:"tab-item-card"},[_vm._t("prepend"),_c('v-card-text',[_vm._t("default")],2)],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }